<template>
  <div class="staff">
    <el-dialog
      :title="text + '员工'"
      :visible.sync="dialogVisible"
      @opened="handleDialogOpened"
      custom-class="staff-dialog"
    >
      <el-form :model="form" :rules="rules" ref="form" autocomplete="off">
        <el-form-item label="真实名称:" label-width="120px" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="角色权限:" label-width="120px" prop="role_id">
          <el-select v-model="form.role_id" placeholder="请选择角色" filterable>
            <el-option
              v-for="item in roleList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户名:" label-width="120px" prop="username">
          <el-input
            ref="usernameInput"
            v-model="form.username"
            name="staff-username"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码:" label-width="120px" prop="password">
          <el-input
            ref="passwordInput"
            type="password"
            placeholder="请输入密码"
            v-model="form.password"
            name="staff-new-password"
            autocomplete="new-password"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="关联主体:" label-width="120px" prop="companies">
          <el-select
            v-model="form.companies"
            placeholder="请选择关联主体"
            filterable
            multiple
          >
            <el-option
              v-for="item in platformConf"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="游戏:" label-width="120px" prop="game_ids">
          <el-select
            v-model="form.game_ids"
            placeholder="请选择游戏"
            filterable
            multiple
          >
            <el-option
              v-for="item in gamesList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="渠道:"
          label-width="120px"
          prop="channel_ids"
          class="staff-channel-form-item"
        >
          <div class="staff-channel-panel">
            <div class="select-all">
              <span>全选：</span>
              <el-switch
                v-model="selectAllChannel"
                @change="handleSelectAllChannelChange"
              >
              </el-switch>
            </div>
            <div class="filter-conditions">
              <span class="filter-conditions-label">筛选条件：</span>
              <el-input
                class="filter-channel-search"
                placeholder="搜索渠道"
                v-model="searchChannel"
                clearable
              >
              </el-input>
              <el-button
                size="small"
                class="filter-action-button"
                @click="clearChannelFilters"
                >清空筛选条件</el-button
              >
              <el-button
                size="small"
                :type="isFilteredChannelAllChecked ? 'warning' : 'primary'"
                plain
                class="filter-action-button"
                :disabled="!filteredChannelList.length"
                @click="toggleFilteredChannels"
                >{{
                  isFilteredChannelAllChecked ? "取消筛选结果" : "勾选筛选结果"
                }}</el-button
              >
            </div>
            <el-checkbox-group
              v-model="form.channel_ids"
              class="staff-channel-checkbox-group"
            >
              <el-checkbox
                v-for="item in filteredChannelList"
                :key="item.value"
                :label="item.value"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
    <commonTable
      ref="commonTable"
      url="/admin/staff/list"
      reqMethod="GET"
      :column="column"
      :searchColumn="searchColumn"
      limitKey="per_page"
    >
      <template #search>
        <el-button
          type="primary"
          icon="el-icon-plus"
          v-if="hasPermission('员工新增')"
          @click="onAdd()"
          >新增</el-button
        >
      </template>
      <el-table-column label="状态" width="100">
        <template slot-scope="scope">
          <el-switch
            @change="changeStatus(scope.row.id, scope.row.status)"
            v-model="scope.row.status"
            :active-value="0"
            :inactive-value="1"
            :disabled="!hasPermission('员工状态编辑')"
            active-color="#13ce66"
            inactive-color="#C0CCDA"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="170" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            plain
            v-if="hasPermission('员工修改')"
            @click="onEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            type="success"
            size="small"
            plain
            v-if="hasPermission('员工新增')"
            @click="onCopy(scope.row)"
            >复制</el-button
          >
        </template>
      </el-table-column>
    </commonTable>
  </div>
</template>

<script>
import fetch from "@/assets/js/axios.js";
import _ from "lodash";

import commonTable from "@/component/commonTable.vue";
import { platformConf } from "@/assets/js/common";

const createEmptyStaffForm = () => ({
  name: "",
  role_id: "",
  channel_ids: [],
  game_ids: [],
  username: "",
  password: "",
  companies: [],
});

export default {
  name: "staff",
  data() {
    return {
      isEdit: "",
      dialogVisible: false,
      roleList: [],
      channelList: [],
      gamesList: [],
      searchChannel: "",
      selectAllChannel: false,
      form: createEmptyStaffForm(),
      platformConf,
    };
  },
  computed: {
    rules() {
      const flag = Boolean(this.isEdit === "");
      const validatePass = (rule, value, callback) => {
        if (!flag && !value) callback();
        if (!value) {
          callback(new Error("请输入密码"));
        } else if (
          !/^\S*(?=\S{8,})(?=\S*\d)(?=\S*[A-Z])(?=\S*[a-z])\S*$/.test(value)
        ) {
          callback(new Error("密码不低于8位数，且必须包含大小写字母和数字"));
        } else {
          callback();
        }
      };
      return {
        name: [{ required: true, message: "请填写真实名称", trigger: "blur" }],
        role_id: [{ required: true, message: "请选择角色", trigger: "change" }],
        // game_ids: [
        //   { required: true, message: '请选择游戏', trigger: 'change' }
        // ],
        // channel_ids: [
        //   { required: true, message: '请选择渠道', trigger: 'change' }
        // ],
        username: [
          { required: true, message: "请填写用户名", trigger: "change" },
        ],
        password: [
          { required: flag, validator: validatePass, trigger: "blur" },
        ],
      };
    },
    text() {
      return this.isEdit !== "" ? "编辑" : "新增";
    },
    filteredChannelList() {
      const keyword = this.searchChannel.trim();
      return this.channelList.filter((item) => item.label.includes(keyword));
    },
    filteredChannelIds() {
      return this.filteredChannelList.map((item) => item.value);
    },
    isFilteredChannelAllChecked() {
      const checkedIdSet = new Set(
        this.form.channel_ids.map((id) => String(id)),
      );
      return (
        this.filteredChannelIds.length > 0 &&
        this.filteredChannelIds.every((id) => checkedIdSet.has(String(id)))
      );
    },
    column() {
      return [
        {
          label: "员工ID",
          prop: "id",
        },
        {
          label: "员工账号",
          prop: "username",
        },
        {
          label: "员工姓名",
          prop: "name",
        },
        {
          label: "角色ID",
          prop: "role_id",
        },
        {
          label: "角色权限",
          prop: "user_role.role_name",
        },
        {
          label: "添加时间",
          prop: "created_at",
        },
        {
          label: "更新时间",
          prop: "updated_at",
        },
      ];
    },
    searchColumn() {
      return [
        {
          label: "员工名字",
          prop: "name",
          type: "input",
        },
        {
          label: "状态",
          prop: "status",
          type: "select",
          option: [
            {
              value: 0,
              label: "正常",
            },
            {
              value: 1,
              label: "封禁",
            },
            {
              value: 2,
              label: "离职",
            },
          ],
        },
        {
          label: "角色",
          prop: "role_id",
          type: "select",
          option: this.roleList,
        },
      ];
    },
  },
  watch: {
    "form.channel_ids": {
      handler() {
        this.updateSelectAllChannelState();
      },
      deep: true,
    },
  },
  methods: {
    // 员工状态 更改
    changeStatus(id, status) {
      let sta;
      if (status === 0) {
        sta = 0;
      } else {
        sta = 1;
      }
      fetch({
        url: "/admin/staff/edit",
        method: "GET",
        params: {
          id: id,
          status: sta,
        },
      });
    },
    resetForm() {
      this.searchChannel = "";
      this.selectAllChannel = false;
      this.form = createEmptyStaffForm();
    },
    buildStaffForm(item, overrides = {}) {
      const form = createEmptyStaffForm();
      const multiValueKeys = ["channel_ids", "game_ids", "companies"];

      Object.keys(form).forEach((key) => {
        if (_.isNil(item[key]) || item[key] === "") return;

        if (multiValueKeys.includes(key)) {
          const values = Array.isArray(item[key])
            ? item[key]
            : String(item[key]).split(",");
          form[key] =
            String(item[key]) === "0"
              ? []
              : values
                  .filter(Boolean)
                  .map((value) =>
                    key === "companies" ? value : Number(value),
                  );
          return;
        }

        form[key] = item[key];
      });

      return {
        ...form,
        ...overrides,
      };
    },
    resetDialogScroll() {
      this.$nextTick(() => {
        const dialogBody = this.$el.querySelector(
          ".staff-dialog .el-dialog__body",
        );
        if (dialogBody) {
          dialogBody.scrollTop = 0;
        }
      });
    },
    clearNewStaffCredentials() {
      this.form.username = "";
      this.form.password = "";

      this.$nextTick(() => {
        ["usernameInput", "passwordInput"].forEach((refName) => {
          const inputComponent = this.$refs[refName];
          if (inputComponent && inputComponent.$refs.input) {
            inputComponent.$refs.input.value = "";
          }
        });
      });
    },
    handleDialogOpened() {
      this.resetDialogScroll();
      if (this.isEdit === "") {
        this.clearNewStaffCredentials();
      }
    },
    handleSelectAllChannelChange(val) {
      if (val) {
        this.form.channel_ids = this.channelList.map((item) => item.value);
      } else {
        this.form.channel_ids = [];
      }
    },
    updateSelectAllChannelState() {
      const allIds = this.channelList.map((item) => item.value);
      const checkedIdSet = new Set(
        this.form.channel_ids.map((id) => String(id)),
      );
      this.selectAllChannel =
        allIds.length > 0 && allIds.every((id) => checkedIdSet.has(String(id)));
    },
    selectFilteredChannels() {
      const checkedList = [...this.form.channel_ids];
      const checkedIdSet = new Set(checkedList.map((id) => String(id)));
      this.filteredChannelIds.forEach((id) => {
        if (!checkedIdSet.has(String(id))) {
          checkedList.push(id);
          checkedIdSet.add(String(id));
        }
      });
      this.form.channel_ids = checkedList;
      this.updateSelectAllChannelState();
    },
    unselectFilteredChannels() {
      const filteredIds = new Set(
        this.filteredChannelIds.map((id) => String(id)),
      );
      this.form.channel_ids = this.form.channel_ids.filter(
        (id) => !filteredIds.has(String(id)),
      );
      this.updateSelectAllChannelState();
    },
    toggleFilteredChannels() {
      if (this.isFilteredChannelAllChecked) {
        this.unselectFilteredChannels();
      } else {
        this.selectFilteredChannels();
      }
    },
    clearChannelFilters() {
      this.searchChannel = "";
    },
    onEdit(item) {
      this.resetForm();
      this.isEdit = item.id;
      this.form = this.buildStaffForm(item);
      this.updateSelectAllChannelState();
      this.dialogVisible = true;
      this.resetDialogScroll();
    },
    onCopy(item) {
      this.resetForm();
      this.isEdit = "";
      this.form = this.buildStaffForm(item, {
        name: "",
        username: "",
        password: "",
      });
      this.updateSelectAllChannelState();
      this.dialogVisible = true;
      this.resetDialogScroll();
    },
    onAdd() {
      this.isEdit = "";
      this.resetForm();
      this.dialogVisible = true;
      this.resetDialogScroll();
    },
    submitForm() {
      let flag = true;
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          flag = false;
          return false;
        }
      });
      if (!flag) return;
      const data = {};
      const form = _.cloneDeep(this.form);
      form.channel_ids =
        form.channel_ids && form.channel_ids.length
          ? form.channel_ids.join(",")
          : "0";
      form.game_ids =
        form.game_ids && form.game_ids.length ? form.game_ids.join(",") : "";
      form.companies =
        form.companies && form.companies.length ? form.companies.join(",") : "";
      for (let key in form) {
        data[key] = form[key];
      }
      let url = "register";
      if (this.isEdit !== "") {
        url = "update";
        data["id"] = this.isEdit;
        data["password"] = data["password"] || "";
      }
      fetch({
        url: `/admin/staff/${url}`,
        method: "POST",
        data,
      }).then((res) => {
        if (res.data.status) {
          this.$message({
            type: "success",
            message: this.text + "成功",
          });
          this.$refs["form"].resetFields();
          this.$refs["commonTable"].reload();
          this.dialogVisible = false;
        } else {
          this.$message({
            type: "error",
            message: res.data.message,
          });
        }
      });
    },
    getGameSelectList() {
      fetch({
        url: "/admin/games/select",
        method: "GET",
      }).then((res) => {
        if (res.data.status) {
          this.gamesList = res.data.data.map((item) => {
            return {
              value: Number(item.id),
              label: item.name,
            };
          });
        }
      });
    },
    getChannelList() {
      fetch({
        url: "/admin/channels/select",
        method: "GET",
      }).then((res) => {
        this.channelList = res.data.data.map((item) => {
          return {
            value: Number(item.id),
            label: item.name,
          };
        });
        this.updateSelectAllChannelState();
      });
    },
    getRoleList() {
      fetch({
        url: "/admin/staff/role_select",
        method: "GET",
      }).then((res) => {
        if (res.data.status) {
          this.roleList = res.data.data.map((item) => {
            return {
              value: item.id,
              label: item.name,
            };
          });
        }
      });
    },
  },
  mounted() {
    this.getRoleList();
    this.getChannelList();
    this.getGameSelectList();
    this.platformConf = this.platformConf.filter((item) => {
      if (process.env.VUE_APP_ENV === "test" || !process.env.VUE_APP_ENV)
        return true;
      return item.value !== "test";
    });
  },
  components: {
    commonTable,
  },
};
</script>

<style lang="less" scoped>
.staff-channel-form-item {
  margin-bottom: 22px;
}

/deep/ .staff-dialog {
  margin-top: 5vh !important;
}

/deep/ .staff-dialog .el-dialog__body {
  max-height: 70vh;
  overflow-y: auto;
  padding-right: 24px;
}

.staff-channel-panel {
  width: 100%;
}

.select-all {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.filter-conditions {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 10px 0 14px;
  flex-wrap: nowrap;
}

.filter-conditions-label {
  flex: 0 0 auto;
  white-space: nowrap;
  color: inherit;
}

.filter-channel-search {
  width: 260px;
}

.filter-action-button {
  min-width: 130px;
  height: 36px;
  padding: 0 16px;
  font-size: 14px;
}

.staff-channel-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.staff-channel-checkbox-group /deep/ .el-checkbox {
  display: flex;
  align-items: center;
  min-width: 240px;
  padding: 5px 0;
  margin-right: 12px;
}
</style>
